import React from 'react'
import { callTodayIcon } from 'src/designSystem/icons'
import { VideoCallType } from 'src/graphql.generated'
import IndicatorChip from './IndicatorChip'
import { callTodayLabel } from './callTodayUtils'

type Props = {
  callType: VideoCallType
  startTime: Date
  expanded?: boolean
}

const CallTodayIndicator = ({ callType, startTime, expanded = false }: Props) => (
  <IndicatorChip
    tooltip={callTodayLabel(callType, startTime)}
    label={expanded ? 'Call today' : undefined}
    testId="call-today-indicator"
  >
    <img src={callTodayIcon} alt="" />
  </IndicatorChip>
)

export default CallTodayIndicator
